/************************************************************
 Patient Namespace
 ************************************************************/

window.PatientNS = {
    getPatientOtherInfo: function(params, callback){
        $.getJSON('/patients/patient_other_info', {patient_id: params.patient_id})
            .done(function (data, status, xhr) {
                if(callback){
                    callback(data);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
            });
    },
    showPatientAlerts: function(patientId,showAllergiesAllerts,showDiagnosisAllerts,showOthersAllerts){
        Hades.showLoading();

        var params = {
            patient_id: patientId,
            show_allergies_allerts: showAllergiesAllerts,
            show_diagnosis_allerts: showDiagnosisAllerts,
            show_others_allerts: showOthersAllerts
        };

        $.get('/patients/patient_alerts_modal', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content: data, autoScale: true, autoDimensions: true});

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
            });
    },

    showMissingDataAlert: function (params) {

        Hades.hideLoading();
        bootbox.alert("O utente encontra-se com dados em falta. Irá ser direcionado para a ficha de utente para alterar os dados.", function () {
            Hades.loadShortcut(globalConstants.SHORTCUT_VIEW_PATIENT, {id: params.id});
        });

    },

    validatePatientDataConfig: function(patient_id, callback, info){

        $.get('/khis_util/get_sys_conf', {code: globalConstants.ENABLE_PATIENT_VALIDATION_DATA}, null, "json")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                debug.log("data", data.value);
                if (data.value.toLowerCase() === "true"){
                    PatientNS.validatePatientData(patient_id, callback, info)
                }
                else{
                    if(callback) {
                        callback(info.sh_id, info.params);
                    }
                }

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
            });

    },

    validatePatientData: function (patient_id, callback, info) {

        $.getJSON('/patients/get_patient_info/', {patient_id: patient_id})
            .done(function (data, status, xhr) {

                debug.log("get_patient_info", data);
                if (data.nnu == null || data.fiscal_number == null){
                    PatientNS.showMissingDataAlert({id: patient_id})
                    return false;
                }
                else{
                    debug.log("callback");
                    if (callback) {
                        callback(info.sh_id, info.params);
                    }
                }

            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
            });

    }

}